/**
 * The key is the join between the application registry (`Application.key` in
 * user-service) and the role catalogue in `application-roles.ts`, so both read it
 * from here and a typo in either cannot split them.
 */
export const APPLICATION_KEYS = {
  platform: 'platform',
  projectManagement: 'project-management',
  onboarding: 'onboarding',
  training: 'training',
  syncConsole: 'sync-console',
  retiring: 'retiring',
  other: 'other',
} as const;

export type ApplicationKey = (typeof APPLICATION_KEYS)[keyof typeof APPLICATION_KEYS];

/** The applications a person can sign in to, and so the only keys a sign-in may name as its target. */
export const SIGN_IN_APPLICATION_KEYS = [
  APPLICATION_KEYS.platform,
  APPLICATION_KEYS.projectManagement,
  APPLICATION_KEYS.onboarding,
  APPLICATION_KEYS.training,
  APPLICATION_KEYS.syncConsole,
] as const;

export type SignInApplicationKey = (typeof SIGN_IN_APPLICATION_KEYS)[number];

/** The key if it names an application, else undefined: an unknown key is ignored, never an error. */
export const signInApplicationKeyOf = (value: unknown): SignInApplicationKey | undefined =>
  SIGN_IN_APPLICATION_KEYS.find((key) => key === value);
